<template>
  <div
    class="group flex w-full cursor-pointer gap-3 py-1 transition-all duration-300"
    :class="{
      'bg-state-bgr-default hover:border-bdr-hover hover:bg-bgr-hover focus-within:border-bdr-focus! rounded-lg border border-transparent px-3 py-2':
        framed,
      'bg-bgr-default border-bdr-default! border': framed && inputValue,
      'bg-state-bgr-disabled cursor-not-allowed!': readonly,
    }"
    @click="() => (readonly ? null : (inputValue = !inputValue))"
  >
    <TickerCheckbox
      :model-value="inputValue"
      :error="error"
      :readonly="readonly"
      :tooltip="tooltip"
      :active-value="activeValue"
      :indeterminate="indeterminate"
    />
    <slot>
      <div class="flex flex-col gap-1">
        <p
          class="text-body-default-m"
          :class="{
            'text-state-fgr-default': !readonly,
            'text-state-fgr-disabled': readonly,
          }"
          v-html="title"
        />
        <p v-if="subtitle" class="text-body-default text-fgr-secondary" v-html="subtitle" />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      error?: boolean;
      name?: string;
      readonly?: boolean;
      tooltip?: string;
      activeValue?: boolean | number;
      indeterminate?: boolean;
      title?: string;
      subtitle?: string;
      framed?: boolean;
      modelValue?: boolean | number;
    }>(),
    {
      name: "",
      tooltip: "",
      title: "",
      subtitle: "",
      framed: false,
      activeValue: false,
      modelValue: false,
    }
  );

  const emit = defineEmits(["update:modelValue"]);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    setValue,
  } = useField(() => props.name, undefined, {
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });

  watch(inputValue, (newValue) => {
    emit("update:modelValue", newValue);

    (document?.activeElement as HTMLElement)?.blur();
  });
</script>
